import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-per-insegnanti',
  templateUrl: './per-insegnanti.component.html',
  styleUrls: ['./per-insegnanti.component.css']
})
export class PerInsegnantiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
